<template>
    <div class="swiper-container">
        <div class="swiper manufacturers-carousel">
            <div class="swiper-wrapper">
                <div class="swiper-slide no-select-slide" v-for="manufacturer in manufacturerList" :key="manufacturer.link.text">
                    <a target="_top" :href="manufacturer.link.url">
                        <img class="img-fluid" :src="getImageUrl(manufacturer.image.urls[0])" alt="" />
                    </a>
                </div>
            </div>
        </div>
        <div class="swiper-button-next swiper-navigation-yellow"></div>
        <div class="swiper-button-prev swiper-navigation-yellow"></div>
    </div>
</template>

<script>
    import gql from 'graphql-tag';
    import Swiper from 'swiper';
    import SwiperCore, { Navigation, Pagination } from 'swiper/core';
    SwiperCore.use([Navigation, Pagination]);

    export default {
        data() {
            return {
                swiper: null,
                manufacturerList: [],
                cmsBaseUrl: process.env.VUE_APP_CMS_BASE_URL,
            }
        },
        computed: {
            getManufacturers() {
                return this.blockCollection[0].blocks.contentItems;
            },
        },
        watch: {
            blockCollection: {
                handler() {
                    this.manufacturerList = this.getManufacturers;
                    this.$nextTick(() => {
                        this.swiperInnit();
                    })
                }
            }
        },
        apollo: {
            blockCollection: {
                query: gql`
                    {
                      blockCollection(where: {displayText: "Manufacturers"}) {
                        blocks {
                          contentItems {
                            ... on BlockSingle {
                              image {
                                urls
                              }
                              link {
                                text
                                url
                              }
                            }
                          }
                        }
                      }
                    }
                `,
            }
        },
        methods: {
            swiperInnit() {
                this.swiper = new Swiper(".manufacturers-carousel", {
                    slidesPerView: "auto",
                    loop: true,
                    spaceBetween: 30,
                    navigation: {
                        nextEl: "#HomeManufacturer .swiper-button-next",
                        prevEl: "#HomeManufacturer .swiper-button-prev",
                    },
                    breakpoints: {
                        992: {
                            slidesPerView: 3,
                        },
                        1200: {
                            slidesPerView: 4,
                        }
                    }
                });
            },
            getBaseUrl() {
                var IS_STAG = window.location.host.indexOf("inprogress") > -1 || window.location.host.indexOf("localhost") > -1;
                if (IS_STAG) this.cmsBaseUrl = 'https://dunloptyres-oc-qa.azurewebsites.net';

                return this.cmsBaseUrl;
            },
            getImageUrl(imagePath) {
                var fullPath = this.getBaseUrl() + imagePath;
                return fullPath;
            }
        },
    };
</script>